import { render, staticRenderFns } from "./ladderScheme.vue?vue&type=template&id=2a854099&scoped=true"
import script from "./ladderScheme.vue?vue&type=script&lang=js"
export * from "./ladderScheme.vue?vue&type=script&lang=js"
import style0 from "./ladderScheme.vue?vue&type=style&index=0&id=2a854099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a854099",
  null
  
)

export default component.exports